import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../storeUtils";
import { t } from "i18next";

const initialState = {
  userRoleList: [],
  isUserRoleListLoaded: false,
};

export const authReducer = (state = initialState, action = { type: "" }) => {
  switch (action.type) {
    case `${actionTypes.FETCH_ROLE_LIST_VIEW}`:
      return updateObject(state, { isUserRoleListLoaded: false });
    case `${actionTypes.FETCH_ROLE_LIST_VIEW}_SUCCESS`:
      const { userViews } = action.payload;
      const getUserViews = (role) => {
        switch (role) {
          case "Trial Master File":
            return t("ADMIN.TEXT_TMF");
          case "TMF Admin":
            return t("ADMIN.TEXT_TMFADMIN");
          case "TMF Archive":
            return t("ADMIN.TEXT_ARCHIVE");

          default:
        }
      };
      const newUserViewList = userViews.map((userView) => getUserViews(userView))
      return updateObject(state, { userRoleList: [...newUserViewList], isUserRoleListLoaded: true });
    case `${actionTypes.FETCH_ROLE_LIST_VIEW}_FAILED`:
      return updateObject(state, { isUserRoleListLoaded: false });
    case `${actionTypes.STUDY_INFO_DB_CHECK}`:
      return updateObject(state, { isloaded: false });
    case `${actionTypes.STUDY_INFO_DB_CHECK}_SUCCESS`:
      return updateObject(state, { isloaded: false });
    case `${actionTypes.STUDY_INFO_DB_CHECK}_FAILED`:
      return updateObject(state, { isloaded: true });
    default:
      return state;
  }
};
